<div class="persona-inner-container">
  <div class="bolt-container-fluid">
    <div class="bolt-row">
      <div class="bolt-col-md-12 bolt-col-lg-3 description-column">
        <div class="persona-description">
          <h3 class="smart-bundle-heading">
            <strong>Features included</strong>
          </h3>
          @if (!isProtectorVersionTabActive) {
            <div class="smart-bundle-subheading">
              <p>
                Here are the coverages and programs included in the base quote.
              </p>
              <p>
                Go to the <strong>Protector Package Quote</strong> to include other options your
                client needs.
              </p>
            </div>
          }
          @if (isProtectorVersionTabActive) {
            <div class="smart-bundle-subheading">
              <p>
                {{ selectedPersonaDescription() }}
              </p>
            </div>
          }
        </div>
        <bolt-button
          class="help-button no-left-padding"
          type="ghost"
          size="sm"
          color="vibrantBlue"
          (click)="displayHelpModal()"
          iconleft="question-circle"
          >
          Learn more about these coverages
        </bolt-button>
      </div>
      @for (product of products; track product) {
        <div class="bolt-col-lg-3 bolt-col-md-6 bolt-col-xs-12 product-card-col">
          <div class="product-card">
            <div
              class="bolt-row bolt-justify-content-between bolt-space-bottom-sm header-row"
              >
              <div class="bolt-col-8">
                <h5 class="bolt-subheading-lg">
                  <strong>{{ getProductDisplayName(product) }}</strong>
                </h5>
              </div>
              @if (getProductIconName(product).length > 0) {
                <div class="bolt-col-4 no-left-padding product-header-icon">
                  <img
                    [src]="'/assets/images/icons/' + getProductIconName(product)"
                    role="presentation"
                    />
                  </div>
                } @else {
                  <div class="bolt-col-4 no-left-padding"></div>
                }
              </div>
              <!-- Show recommendations if available -->
              @if (hasRecommendationsForProduct(product)) {
                @for (recommendation of getProductRecommendations(product); track recommendation.id) {
                  <div
                    class="bolt-row recommendation-row"
                    >
                    <div class="bolt-col-auto">
                      @if (!isRecommendationPresent(recommendation)) {
                        <ng-container
                          class="not-present"
                          >
                          <bolt-icon
                            name="minus"
                            role="presentation"
                            class="tile-img"
                          ></bolt-icon>
                        </ng-container>
                      } @else {
                        <bolt-icon
                          name="checkmark-circle-filled"
                          color="vibrantBlue"
                          decorative
                          class="float-left"
                        ></bolt-icon>
                      }
                    </div>
                    <div
                      class="bolt-col normal-line-height"
                [ngClass]="{
                  'not-present': !isRecommendationPresent(recommendation)
                }"
                      >
                      {{ getRecommendationDisplayDetails(recommendation.id)?.label }}
                    </div>
                  </div>
                }
              }
              <!-- Show placeholder when no recommendations but product exists -->
              @if (!hasRecommendationsForProduct(product)) {
                <div class="bolt-row recommendation-row">
                  <div class="bolt-col normal-line-height">
                    Coverage options available for this product.
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
